import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';

@Component({
  selector: 'app-business-return-on-capital-calculator',
  templateUrl: './business-return-on-capital-calculator.component.html',
  styleUrls: ['./business-return-on-capital-calculator.component.css']
})
export class BusinessReturnOnCapitalCalculatorComponent implements OnInit {

  form;
  ngOnInit () {

    this.form = new FormGroup ( {

    value1: new FormControl(''),
    value2: new FormControl(''),
    value3: new FormControl(''),
    value4: new FormControl(''),
    } )

  } 
  reOc(n1,n2,n3,n4){
    var plAva=((n1)/(n3+n2-(n4)));
    var plAvasimple= plAva.toFixed(2);
    return plAvasimple ;
  }

}



// WEBPACK FOOTER //
// C:/my-dream-app/src/app/business-return-on-capital-calculator/business-return-on-capital-calculator.component.ts